// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
// ##### Komarov 2025-07-25
import { isServer } from '../../../../server/helpers/browserDetector';

// ##### Komarov 2025-07-14
const SeoMetaDescription = ({ metaDescriptionText }) => {
  // ##### 24-03-21 Komarov
  const clearMetaTags = metaTags => {
    for (let i = 0; i < metaTags.length; i++) {
      const metaTag = metaTags[i];
      const name = metaTag.getAttribute('name');

      if (!metaTag.hasAttribute('data-rh') && name === 'description') {
        // Удаляем тег meta без атрибута data-rh
        metaTag.remove();
      }
    }
  };
  // ##### Komarov 2025-07-12
  // Удаляем теги meta, которые пришли с сервера (потому что на клиенте они не заменяются, а к ним добавляются ещё и клиентские meta-теги)
  useEffect(() => {
    // Проходим по всем тегам meta и удаляем теги без атрибута data-rh
    if (!isServer) {
      const metaTags = document.getElementsByTagName('meta');
      clearMetaTags(metaTags);
    }
  }, []);

  return (
    <Helmet>
      {/* ##### 24-09-13 Komarov */}
      <meta name="description" content={metaDescriptionText} />
    </Helmet>
  );
};

// ##### 25-05-21 Komarov
export default SeoMetaDescription;
